<template>
  <div>
    <div
      v-if="isURL(value)"
      class="message ma-1"
      style="position:relative;border-radius: 12px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
      :style="{
        float: align,
        width: width
      }"
    >
      <div style="font-size: 12px;color:black; line-height: 0;margin-top: 0">
        <img :src="value" alt style="width: 100%" />
      </div>

      <div style="height: 100%; position: absolute; top: 0; right: 0; left: 0; bottom: 0">
        <v-layout justify-center align-center row style="height: 100%">
          <div class="text-xs-center">
            <v-btn small fab color="#00000059" dark @click="showImage">
              <v-icon>search</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>
    </div>
    <div
      v-else-if="value.includes('base64,')"
      class="message ma-1"
      style="position:relative;border-radius: 12px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
      :style="{
        float: align,
        width: width
      }"
    >
      <div style="font-size: 12px;color:black; line-height: 0;margin-top: 0">
        <img :src="value" alt style="width: 100%" />
      </div>

      <div style="height: 100%; position: absolute; top: 0; right: 0; left: 0; bottom: 0">
        <v-layout justify-center align-center row style="height: 100%">
          <div class="text-xs-center">
            <v-btn small fab color="#00000059" dark @click="showImage">
              <v-icon>search</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>
    </div>
    <div
      class="message"
      v-else
      style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;    white-space: initial;"
      :style="{ float: align }"
    >
      <div style="font-size: 12px;" :style="{ color: 'black' }">
        <div style="padding: 5px 8px 6px;" :style="{ 'background-color': 'grey' }">
          <span style="line-height:15.36px; line-height: 22px;">
            <template v-if="value != ''">
              <specialtext :text="value"></specialtext>
            </template>
            <template v-else>-</template>
          </span>
        </div>
      </div>
    </div>

    <v-dialog v-model="showPreviewImage" max-width="600">
      <v-card v-if="value">
        <div class="text-xs-right">
          <v-btn fab small flat @click="showPreviewImage = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <!-- <product-zoomer :base-images="previewImage" :base-zoomer-options="zoomerOptions" /> -->
          <img :src="value" style="width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import ProductZoomer from 'vue-product-zoomer'
import specialtext from '@/components/elements/specialtext'

export default {
  props: ['value', 'width', 'align'],
  data() {
    return {
      showPreviewImage: false,

      zoomerOptions: {
        zoomFactor: 4,
        pane: 'container',
        hoverDelay: 300,
        namespace: 'inline-container',
        move_by_click: false,
        scroll_items: 7,
        choosed_thumb_border_color: '#dd2c00',
        scroller_position: 'right',
      },
      previewImage: null,
    }
  },
  components: {
    specialtext,
    // ProductZoomer
  },
  computed: {},
  mounted() {
    this.previewImage = [
      {
        // required
        normal_size: [{ id: 1, url: this.value }],
      },
    ]
  },

  methods: {
    async showImage() {
      await this.$nextTick()
      this.showPreviewImage = true
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/ImageType.vue